<template>
  <footer class="bg-bleumarine text-white">
    <div class="container mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Company Info -->
        <div>
          <div class="flex items-center mb-4">
            <div class="bg-white rounded-lg p-2">
              <img src="@/assets/logo.png" alt="TechsPartner Logo" class="w-14 h-14 object-contain">
            </div>
          </div>
          <p class="text-gray-400 text-sm">
            Votre partenaire de confiance pour la transformation digitale en Afrique subsaharienne.
          </p>
          <div class="flex items-start">
            <div class="w-12 h-12 bg-violet rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
              <Clock class="w-6 h-6" :stroke="'#fff'" />
            </div>
            <div>
              <h3 class="font-semibold mb-1">Horaires</h3>
              <p class="text-gray-300">Lundi - Vendredi: 8h00 - 17h00</p>
            </div>
          </div>
        </div>

        <!-- Quick Links -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Liens Rapides</h3>
          <ul class="space-y-2">
            <li><router-link to="/" class="text-gray-300 hover:text-white transition">Accueil</router-link></li>
            <li><router-link to="/services" class="text-gray-300 hover:text-white transition">Services</router-link></li>
            <li><router-link to="/about" class="text-gray-300 hover:text-white transition">À propos</router-link></li>
            <li><router-link to="/blog" class="text-gray-300 hover:text-white transition">Blog</router-link></li>
            <li><router-link to="/contact" class="text-gray-300 hover:text-white transition">Contact</router-link></li>
          </ul>
        </div>

        <!-- Services -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Nos Services</h3>
          <ul class="space-y-2 text-sm text-gray-300">
            <li>Datacenter & Cloud</li>
            <li>Réseaux & Télécom</li>
            <li>Développement Web</li>
            <li>Sécurité SI</li>
            <li>Audit IT</li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Contact</h3>
          <ul class="space-y-2 text-sm text-gray-300">
            <li class="flex items-start">
              <MapPin class="w-5 h-5 mr-2 mt-0.5" :stroke="'#fff'" />
              BP 561 Bingerville, Côte d'Ivoire
            </li>
            <li class="flex items-center">
              <Mail class="w-5 h-5 mr-2" :stroke="'#fff'" />
              infos@techspartner.com
            </li>
            <li class="flex items-center">
              <Phone class="w-5 h-5 mr-2" :stroke="'#fff'" />
              +225 21 50 03 48 12 / +225 01 50 54 74
            </li>
          </ul>
        </div>
      </div>

      <!-- Newsletter -->
      <div class="mt-12 pt-8 border-t border-turquoise">
        <div class="max-w-md mx-auto">
          <h3 class="text-lg font-semibold mb-4 text-center">Abonnez-vous à notre newsletter</h3>
          <form @submit.prevent="subscribeNewsletter" class="flex flex-col sm:flex-row gap-3">
            <input 
              type="email" 
              v-model="email"
              placeholder="Votre adresse email"
              class="flex-1 px-4 py-3 rounded-lg bg-white border border-gray-700 text-bleumarine placeholder-gray-400 focus:outline-none focus:border-turquoise"
              required
            >
            <button type="submit" class="btn-primary whitespace-nowrap">S'abonner</button>
          </form>
        </div>
      </div>

      <!-- Copyright -->
      <div class="mt-8 pt-8 border-t border-turquoise text-center text-gray-300 text-sm">
        <p>&copy; {{ currentYear }} TechsPartner. Tous droits réservés.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Clock, MapPin, Mail, Phone } from 'lucide-vue-next'

const email = ref('')

const currentYear = computed(() => new Date().getFullYear())

const subscribeNewsletter = () => {
  // Newsletter subscription logic would go here
  alert('Merci pour votre inscription !')
  email.value = ''
}
</script>


